import type { FaireProductEntity } from "../../entity_types/product";

export const p_dkrrkt7gjp: FaireProductEntity = {
  token: "p_dkrrkt7gjp",
  type: "product",
  name: "Ceremonia’s Fragrance Discovery Set",
  brandToken: "b_4240zqg5kc",
  brandName: "Ceremonia",
  imageUrl:
    "https://cdn.faire.com/fastly/4171738e17594a2771cdc6c42a99b6131d69d0320f5dcc0c802789f470b4c4aa.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 42,
  description: "Fragrance Discovery Set for wholesale.",
  tags: ["fragrance"],
  caseSize: 1,
  isNew: true,
  msrpDollars: 84,
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-04-14T00:00:00.000Z",
    importedBy: "ceremonia-brand-prototype",
  },
  categoryTokens: [],
};
